import React, { useEffect, useState, useRef, Component } from 'react';
import { SearchIcon, XIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
interface SearchModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function SearchModal({
  isOpen,
  onClose
}: SearchModalProps) {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => inputRef.current?.focus(), 100);
    } else {
      setQuery('');
    }
  }, [isOpen]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/otc-products?search=${encodeURIComponent(query.trim())}`);
      onClose();
    }
  };
  const popularSearches = ['Vitamins', 'Pain Relief', 'Allergy', 'First Aid'];
  return <AnimatePresence data-id="element-269">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-[100]" data-id="element-270" />

          <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="fixed top-20 sm:top-32 inset-x-0 mx-auto w-full max-w-2xl px-4 z-[101]" data-id="element-271">
            <div className="bg-white rounded-2xl shadow-2xl overflow-hidden" data-id="element-272">
              <form onSubmit={handleSearch} className="flex items-center border-b border-slate-100 px-4 sm:px-6" data-id="element-273">
                <SearchIcon className="w-5 h-5 text-slate-400 flex-shrink-0" data-id="element-274" />
                <input ref={inputRef} type="text" value={query} onChange={e => setQuery(e.target.value)} placeholder="Search products, vitamins, medications..." className="flex-grow py-4 sm:py-6 px-4 text-sm sm:text-base text-slate-900 placeholder-slate-400 focus:outline-none" data-id="element-275" />
                <button type="button" onClick={onClose} className="p-2 text-slate-400 hover:text-slate-900 transition-colors" data-id="element-276">
                  <XIcon className="w-5 h-5" data-id="element-277" />
                </button>
              </form>

              <div className="p-6" data-id="element-278">
                <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400 mb-4" data-id="element-279">
                  Popular Searches
                </p>
                <div className="flex flex-wrap gap-2" data-id="element-280">
                  {popularSearches.map(term => <button key={term} onClick={() => {
                navigate(`/otc-products?search=${encodeURIComponent(term)}`);
                onClose();
              }} className="px-4 py-2 bg-slate-50 hover:bg-clinical-blue hover:text-white text-slate-700 text-xs font-bold uppercase tracking-wide rounded-full transition-colors" data-id="element-281">
                      {term}
                    </button>)}
                </div>
              </div>

              <div className="px-6 py-4 bg-slate-50 border-t border-slate-100 flex justify-between items-center" data-id="element-282">
                <p className="text-[10px] text-slate-400 uppercase tracking-widest font-bold" data-id="element-283">
                  Press{' '}
                  <kbd className="px-1.5 py-0.5 bg-white rounded border border-slate-200 text-slate-600" data-id="element-284">
                    ESC
                  </kbd>{' '}
                  to close
                </p>
                <button type="submit" onClick={handleSearch} disabled={!query.trim()} className="bg-clinical-blue text-white font-bold py-2.5 px-6 rounded-lg hover:bg-blue-700 transition-colors uppercase tracking-widest text-[10px] disabled:opacity-40 disabled:cursor-not-allowed" data-id="element-285">
                  Search
                </button>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}